import { createSlice } from "@reduxjs/toolkit";

import { RootState, AdminAssignmentState } from "@/types/store";
import {
  assignAdminsToOwner,
  assignOwnersToAdmin,
  getUserAssignments,
  removeAdminFromOwner,
  removeOwnerFromAdmin,
} from "@/api/adminAssignment/thunks";

const initialState: AdminAssignmentState = {
  loading: false,
  mutating: false,
  error: null,
};

export const AdminAssignmentSlice = createSlice({
  name: "AdminAssignmentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserAssignments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserAssignments.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getUserAssignments.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || null;
      });

    [
      assignOwnersToAdmin,
      removeOwnerFromAdmin,
      assignAdminsToOwner,
      removeAdminFromOwner,
    ].forEach((thunk) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.mutating = true;
          state.error = null;
        })
        .addCase(thunk.fulfilled, (state) => {
          state.mutating = false;
        })
        .addCase(thunk.rejected, (state, action) => {
          state.mutating = false;
          state.error = (action.payload as string) || null;
        });
    });
  },
});

export const selectAdminAssignmentLoading = (state: RootState) =>
  state.AdminAssignment.loading;
export const selectAdminAssignmentMutating = (state: RootState) =>
  state.AdminAssignment.mutating;

export default AdminAssignmentSlice.reducer;
